/**
 * Client-side loop prevention for voice assistant multi-turn flows.
 */

const MAX_SAME_QUESTION = 2;
const QUESTION_TIMEOUT_MS = 5 * 60 * 1000;

interface LoopState {
  lastQuestion: string | null;
  repeatCount: number;
  askedAt: number;
  pendingField: string | null;
}

const gva = (): any => {
  const w = window as any;
  if (!w.__GVA_STATE__) w.__GVA_STATE__ = {};
  return w.__GVA_STATE__;
};

export function trackAssistantQuestion(question: string, pendingField?: string): void {
  const state = gva();
  const normalized = question.toLowerCase().trim();
  const loop: LoopState = state.loopGuard || {
    lastQuestion: null,
    repeatCount: 0,
    askedAt: 0,
    pendingField: null,
  };

  if (loop.lastQuestion === normalized) {
    loop.repeatCount += 1;
  } else {
    loop.lastQuestion = normalized;
    loop.repeatCount = 1;
    loop.askedAt = Date.now();
  }
  loop.pendingField = pendingField || loop.pendingField;
  state.loopGuard = loop;
}

export function clearLoopGuard(): void {
  const state = gva();
  delete state.loopGuard;
  delete state.pendingCustomer;
  delete state.pendingSupplier;
}

export function isLoopDetected(): boolean {
  const loop: LoopState | undefined = gva().loopGuard;
  if (!loop) return false;
  if (Date.now() - loop.askedAt > QUESTION_TIMEOUT_MS) {
    clearLoopGuard();
    return false;
  }
  return loop.repeatCount >= MAX_SAME_QUESTION;
}

export function getLoopRecoveryMessage(): string {
  const loop: LoopState | undefined = gva().loopGuard;
  const field = loop?.pendingField;
  if (field === 'contact_name') {
    return "I seem to be having trouble hearing the name. Please type it using the keyboard button, or say the full company name clearly.";
  }
  return "I'm having trouble with this step. Try rephrasing your request or start a new conversation.";
}

export function shouldBlockClientFastTrack(): boolean {
  const state = gva();
  return !!(state.pendingCustomer || state.pendingSupplier || state.loopGuard?.pendingField);
}
